import React from 'react';
import PropTypes from 'prop-types';
import { trim } from 'lodash';
import cn from 'classnames';

import { CHAT, COMMON } from '../../../constants/strings';
import { useForm } from '../../../hocs/useForm';
import sanitizeHtml from '../../../utils/sanitizeHtml';
import { MESSAGE_MAX_LENGTH } from '../../../constants/chat';

import TextInput from '../../TextInput';
import Button from '../../Button';
import ValidationError from '../ValidationError';

const TextMessageForm = ({
  formatMessage,
  onSendMessage,
  onClose,
  className,
}) => {
  const initialValues = {
    message: '',
  };

  const onSubmit = values => {
    const modifiedValue = sanitizeHtml(values.message, true);
    onClose();
    onSendMessage(modifiedValue);
  };

  const validate = (fieldName, value) => {
    let error;
    if (value.length > MESSAGE_MAX_LENGTH) {
      error = formatMessage(
        { id: 'chat.errors.tooLong' },
        { length: MESSAGE_MAX_LENGTH },
      );
    }
    return error;
  };

  const { values, errors, handleChange, handleSubmit } = useForm({
    initialValues,
    onSubmit,
    validate,
  });

  const disabled = Boolean(errors.message) || !trim(values.message);

  return (
    <form onSubmit={handleSubmit} className={cn(className, 'w-100')}>
      <TextInput
        placeholder={formatMessage(CHAT.placeholders.default)}
        rows={4}
        textarea
        name="message"
        value={values.message}
        onChange={text => handleChange('message', text)}
        rounded
      />
      <ValidationError content={errors.message} />
      <div className="mt3">
        <Button
          className="mr3"
          raised
          color="primary"
          type="submit"
          disabled={disabled}
        >
          {formatMessage(COMMON.send)}
        </Button>
        <Button raised color="accent" onClick={onClose}>
          {formatMessage(COMMON.cancel)}
        </Button>
      </div>
    </form>
  );
};

TextMessageForm.propTypes = {
  formatMessage: PropTypes.func,
  onSendMessage: PropTypes.func,
  onClose: PropTypes.func,
  className: PropTypes.string,
};

TextMessageForm.defaultProps = {
  className: 'mb3',
};

export default TextMessageForm;



// WEBPACK FOOTER //
// ./src/components/common/TextMessageForm/index.jsx